import { QueryClient } from '@tanstack/react-query';

/**
 * TanStack Query 클라이언트
 * Day 3-5에서 자세한 옵션 추가 (06_FRONTEND_COMPONENTS.md 참조)
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});
